// nuera-auth-client.js
// Drop this file into ANY NUERA SaaS product
// Usage: import { createAuth } from './nuera-auth-client.js'

import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';

const NUERA_AUTH_URL = 'https://nuera-central-auth.sharathstash21.workers.dev';

// Firebase config — same config for ALL products (same Firebase project)
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBhhGEQ0VvRb2fG_axHtHxXQ5FLHVDfXZg",
  authDomain: "nuera-central-auth.firebaseapp.com",
  projectId: "nuera-central-auth",
  storageBucket: "nuera-central-auth.firebasestorage.app",
  messagingSenderId: "323753161842",
  appId: "1:323753161842:web:87750ee3725efce7023eeb",
  measurementId: "G-YLLPR7CXBX"
};

class NUERAAuthClient {
  constructor(productSlug) {
    this.productSlug = productSlug;
    this.app = initializeApp(FIREBASE_CONFIG, productSlug); // unique name per product
    this.auth = getAuth(this.app);
    this.provider = new GoogleAuthProvider();
    this._token = localStorage.getItem('nuera_token');
    this._user = null;
  }

  // ── Sign in with Google ──
  async signIn() {
    const result = await signInWithPopup(this.auth, this.provider);
    const firebaseToken = await result.user.getIdToken();

    const res = await fetch(`${NUERA_AUTH_URL}/auth/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ firebaseToken, productSlug: this.productSlug }),
    });

    if (!res.ok) {
      const errData = await res.json().catch(() => ({}));
      throw new Error(errData.error || `Auth failed with status ${res.status}`);
    }

    const data = await res.json();
    this._token = data.token;
    this._user = data.user;
    localStorage.setItem('nuera_token', data.token);

    return data;
  }

  // ── Sign out ──
  async signOut() {
    if (this._token) {
      await fetch(`${NUERA_AUTH_URL}/auth/logout`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${this._token}` },
      });
    }
    await signOut(this.auth);
    localStorage.removeItem('nuera_token');
    this._token = null;
    this._user = null;
  }

  // ── Get current user + subscriptions ──
  async getMe() {
    if (!this._token) return null;

    const res = await fetch(`${NUERA_AUTH_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${this._token}` },
    });

    if (!res.ok) {
      this._token = null;
      localStorage.removeItem('nuera_token');
      return null;
    }

    const data = await res.json();
    this._user = data.user;
    return data;
  }

  // ── Check if user has access to this product ──
  async hasAccess() {
    const me = await this.getMe();
    if (!me) return false;
    return me.subscriptions.some(s => s.product_slug === this.productSlug);
  }

  // ── Get stored token (for API calls from this product's Worker) ──
  getToken() {
    return this._token;
  }

  // ── Check if logged in ──
  isLoggedIn() {
    return !!this._token;
  }
}

// Export a factory — each product creates its own instance with its slug
export function createAuth(productSlug) {
  return new NUERAAuthClient(productSlug);
}

// Named export for direct use
export { NUERAAuthClient as NUERAAuth };
